let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cEVMh")).then(() => parcelRequire('hxNsI'));